import DashboardIconOutlined from '@mui/icons-material/DashboardOutlined';
import PriceChangeOutlinedIcon from '@mui/icons-material/PriceChangeOutlined';
import ReceiptOutlinedIcon from '@mui/icons-material/ReceiptOutlined';
import TrendingUpOutlinedIcon from '@mui/icons-material/TrendingUpOutlined';
import StoreOutlinedIcon from '@mui/icons-material/StoreOutlined';
// import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import GavelIconOutlined from '@mui/icons-material/GavelOutlined';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
// import AltRouteIcon from '@mui/icons-material/AltRoute';
import ContactlessOutlinedIcon from '@mui/icons-material/ContactlessOutlined';
// import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import PercentOutlinedIcon from '@mui/icons-material/PercentOutlined';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import { OverviewIcon } from '@img/icons';
import { AuthenticatedUser, navigator } from '@types';
import { getImpersonatedCarrierData } from '@utils';

const carrierNav = (cID?: string, yourLoadCount?: number, isAdmin: boolean = false, authUser?: AuthenticatedUser, isCarrierActive: boolean = true) => {
	const cIDQuery = cID !== '' ? `?cid=${cID}` : '';

	let carrierMenuItems = [
		{
			label: 'Dashboard',
			icon: (color: string) => <DashboardIconOutlined style={{ color: color }} />,
			link: `/carrier/dashboard${cIDQuery}`,
			domain: 'spa' as const,
			enabled: true,
			activeURL: 'dashboard'
		},
		{
			label: 'Overview',
			icon: (color: string) => <OverviewIcon color={color} />,
			link: `/carrier/overview${cIDQuery}`,
			domain: 'spa' as const,
			enabled: isCarrierActive || isAdmin,
			activeURL: 'overview'
		},
		// we need to handle both admin login and carrier login
		...((getImpersonatedCarrierData('is_marketplace_enabled') || authUser?.carrier?.is_marketplace_enabled) ? [
			{
				label: 'Marketplace',
				icon: (color: string) => <GavelIconOutlined style={{ color: color }} />,
				link: `/carrier/marketplace${cIDQuery}`,
				domain: 'spa' as const,
				enabled: isCarrierActive || isAdmin,
				activeURL: 'marketplace'
			}
		] : []),
		{
			label: 'Your Loads',
			icon: (color: string) => <FormatListBulletedIcon style={{ color: color }} />,
			link: `/carrier/your-loads${cIDQuery}`,
			domain: 'spa' as const,
			count: yourLoadCount,
			enabled: true,
			activeURL: 'your-loads'
		},
		{
			label: 'Bulk Update Milestones',
			icon: (color: string) => <UploadFileIcon style={{ color: color }} />,
			link: `/carrier/bulk-upload${cIDQuery}`,
			domain: 'spa' as const,
			enabled: true,
			activeURL: 'bulk-upload'
		},
		{
			label: 'Rate Cards',
			icon: (color: string) => <PriceChangeOutlinedIcon style={{ color: color }} />,
			link: `/carrier/ratecards${cIDQuery}`,
			domain: 'spa' as const,
			enabled: true,
			activeURL: 'ratecards'
		},
		{
			label: 'Invoices',
			icon: (color: string) => <ReceiptOutlinedIcon style={{ color: color }} />,
			link: `/carrier/financials-dashboard${cIDQuery}`,
			domain: 'spa' as const,
			enabled: true,
			activeURL: 'financials-dashboard'
		},
		{
			label: 'Invoice Funding',
			icon: (color: string) => <ContactlessOutlinedIcon style={{ color: color }} />,
			link: `/carrier/invoice-funding${cIDQuery}`,
			domain: 'spa' as const,
			enabled: true,
			activeURL: 'invoice-funding'
		},
		{
			label: 'Analytics',
			icon: (color: string) => <TrendingUpOutlinedIcon style={{ color: color }} />,
			link: `/carrier/analytics${cIDQuery}`,
			domain: 'spa' as const,
			enabled: true,
			activeURL: 'analytics'
		},
		{
			label: 'Exclusive Offers',
			icon: (color: string) => <PercentOutlinedIcon style={{ color: color }} />,
			link: `/carrier/offers${cIDQuery}`,
			domain: 'spa' as const,
			enabled: true,
			activeURL: 'offers'
		},
		{
			label: 'Company Details',
			icon: (color: string) => <StoreOutlinedIcon style={{ color: color }} />,
			link: `/carrier/company-details${cIDQuery}`,
			domain: 'spa' as const,
			enabled: true,
			activeURL: 'company-details'
		},
	];

	carrierMenuItems = carrierMenuItems.filter((item: navigator) => {
		switch (item.activeURL) {
		case 'dashboard':
		case 'bulk-upload':
		case 'ratecards':
			return isAdmin;
		default:
			return true;
		}
	});

	if (isAdmin && !cID) {
		return carrierMenuItems.filter((item: navigator) => item.activeURL === 'dashboard');
	}

	return carrierMenuItems;
}

export default carrierNav;
